import React, { useContext } from "react";
import { makeStyles } from "@material-ui/core/styles";
import TableCell from "@material-ui/core/TableCell";
import TestSeriesTableElement from "./TestSeriesTableElement";
import TestSeriesWhiteChipTableElement from "./TestSeriesWhiteChipTableElement";
import ProductSection from "../../../../../../api/models/test-series/ProductSection";
import ProductActionValueGroup from "../../../../../../api/models/test-series/ProductActionValueGroup";
import ActionFlow from "../../../../../../api/models/test-series/ActionFlow";
import { TestSeriesContext } from "../../../../../../contexts/TestSeriesContext";
import formatIdentifierAsString from "../../../../../../functions/formatIdentifierAsString.function";
import ActionValue from "../../../../../../api/models/test-series/ActionValue";

const useStyles = makeStyles({
  tableCell: {
    border: "1px solid",
    borderColor: "#ECECED",
    verticalAlign: "top",
  },
  cellHeadline2: {
    color: "#757575",
    fontSize: "0.9rem",
    paddingTop: "10px",
    paddingBottom: "10px",
  },
});

interface TestSeriesProductColumnProps {
  enabled: boolean;
  validated: boolean;
  product: ProductSection;
  updateProduct: (product: ProductSection) => void;
}

const TestSeriesProductColumn: React.FunctionComponent<TestSeriesProductColumnProps> = (props) => {
  const classes = useStyles();
  const { enabled, product, updateProduct, validated } = props;
  const { showTextDialog } = useContext(TestSeriesContext);

  function handleChangeSuffix(index: number): Promise<void> | void {
    const flowToChange = product.productActionFlows[index].actionFlow;
    if (flowToChange) {
      return showTextDialog(
        "Enter Suffix",
        flowToChange.nameSuffix,
        "Please enter a suffix to further describe the sample",
        { disabledOnEmpty: true, disabledHint: "Please enter a suffix" },
      )
        .then((nameSuffix) => {
          const newFlows = [...product.productActionFlows];
          newFlows[index].actionFlow = { ...flowToChange, nameSuffix };
          updateProduct({ ...product, productActionFlows: newFlows });
        })
        .catch(() => {
          // do nothing
        });
    }
  }

  function handleDeleteProduct(i: number): void {
    const newArray = [...product.productActionFlows];
    newArray.splice(i, 1);
    product.productActionFlows = newArray;
    // trigger rerender through state update
    updateProduct({ ...product });
  }

  return (
    <TableCell align="left" className={classes.tableCell}>
      <div className={classes.cellHeadline2}>Products</div>
      {product.productActionFlows &&
        product.productActionFlows
          .filter((e) => e.actionFlow)
          .map((e: ProductActionValueGroup, i: number) => {
            return (
              <span key={e.id ? e.id : i}>
                <TestSeriesTableElement
                  enabled={enabled}
                  validated={validated}
                  section="material"
                  primaryChip={(e.actionFlow as ActionFlow).name}
                  primaryChipSuffix={(e.actionFlow as ActionFlow).nameSuffix}
                  primaryChipUnderline={`Side: ${formatIdentifierAsString(e.sideOfProduct)}`}
                  secondaryChips={(e.actionFlow as ActionFlow).actionValues}
                  onChangeSuffix={() => handleChangeSuffix(i)}
                  onPrimaryChipDelete={(): void => {
                    handleDeleteProduct(i);
                  }}
                  updateParentState={(): void => {
                    updateProduct({ ...product });
                  }}
                />
              </span>
            );
          })}
      <div className={classes.cellHeadline2}>Actions on all Products </div>
      <TestSeriesWhiteChipTableElement
        enabled={enabled}
        validated={validated}
        section="material"
        chips={product.actionsOnAllProducts ? product.actionsOnAllProducts.actionValues : []}
        updateParentState={(updatedChips): void => {
          if (!product.actionsOnAllProducts) {
            product.actionsOnAllProducts = {
              name: "",
              actionValues: updatedChips as ActionValue[],
            };
          }
          updateProduct({ ...product });
        }}
      />
    </TableCell>
  );
};
export default TestSeriesProductColumn;
